import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Accordion, Card } from "react-bootstrap";
import {
  renderTableDealsColumns,
  renderTableDealsRows,
  getCollapsedStatus,
  toggleAccordion,
  useSortableData,
  getDateColor,
  onHandleHover,
  onHandleHoverEmpty,
} from "../dashboard-util/dashboard-utils";
import DashboardTableHeader from "./DashboardTableHeader";
import DealsButtonRow from "./DealsButtonRow";
import TableHeaderColumn from "./TableHeaderColumn";
import DealModal from "./DealModal";
import VacationModal from "./VacationModal";
import BookedVacationString from "./BookedVacationString";
import MemberIcon from "../../../components/member-icon/member-icon";
import "../dashboard-real-estate/dashboard-real-estate.scss";

const DashboardDealTracker = ({
  isAllRbc,
  isStaffer,
  realEstateTrackerMembers
}) => {
  const [members, setMembers] = useState([]);
  const [toggled, setToggled] = useState([]);
  const [show, setShow] = useState(false);
  const [showDeals, setShowDeals] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [accordionId, setAccordionId] = useState(`real-estate-dealtracker-accordion`);
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    setMembers(realEstateTrackerMembers);
  }, [realEstateTrackerMembers]);

  const showModal = (m, type) => {
    setSelectedMember(m);
    if (type === 'deals') setShowDeals(true);
    else setShow(true);
  };

  const onHide = () => setShow(false);

  const { items = [], requestSort = () => {}, getArrowDirectionFor = () => {} } = useSortableData(members);

  if (items !== null && items?.length > 0) {
    return (
      <div className="new-dashboard table-wrapper">
        <div className="DashboardTableWrapper">
          <table>
            <thead>
              <tr className="DashboardTableHeader">
                <DashboardTableHeader
                  trackerType="dealtracker"
                  accordionId={accordionId}
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              </tr>
            </thead>
            <Accordion>
              <Card className="MemberTableBodyWrapper">
                <thead className="MemberTableColumnHeader">
                  <tr className="MemberTableColumnTitles">
                    <TableHeaderColumn
                      headerText="ASSOCIATE/ANALYST"
                      sortKey="Name"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-3"
                    />
                    <TableHeaderColumn
                      headerText="BOOKED VACATION"
                      sortKey="BookedVacations"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-3"
                      getBookedVacation={true}
                    />
                    <TableHeaderColumn
                      headerText="ACTIVE DEALS"
                      sortKey="ActiveDeals"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-2"
                    />
                    <TableHeaderColumn
                      headerText="LAST UPDATED"
                      sortKey="LastUpdated"
                      requestSort={requestSort}
                      getArrowDirectionFor={getArrowDirectionFor}
                      colClass="col-md-2"
                    />
                  </tr>
                </thead>
              </Card>
              <table className="real-estate-table">
                <tbody className="real-estate-tablebody">
                  {items?.map((member) => {
                    const memberId = member.UserId;
                    const dealTrackers = member.DealTracker;

                    if (!dealTrackers || dealTrackers.length === 0) return null;

                    return (
                      <React.Fragment key={memberId}>
                        <tr key={`${member?.CompanyId}-${memberId}`} className="real-estate-table-row">
                          <Card>
                            <div className="MemberTableBody realEstateRow row">
                              <td className="col-md-3 mt-2 real-estate-username" onClick={() => { showModal(member, 'deals') }}>
                                <MemberIcon
                                  type="user"
                                  typeColor={member.TypeColor}
                                  className="ml-3"
                                  member={{ userNameFull: member.Name }}
                                />
                                <span className="Memberoverlaybutton mt-1 pl-1">
                                  {" "}
                                  {member.Name}
                                </span>
                              </td>
                              <BookedVacationString
                                item={member}
                                onHandleHover={onHandleHover}
                                onHandleHoverEmpty={onHandleHoverEmpty}
                                showModal={showModal}
                                getDateColor={getDateColor}
                              />
                              <td className="col-md-2 mt-2">
                                {member.ActiveDeals}
                              </td>
                              <td className="col-md-2 mt-2">
                                {member.LastUpdated}
                              </td>
                              <DealsButtonRow
                                {...{
                                  member,
                                  toggled,
                                  showModal,
                                  toggleAccordion,
                                  accordionId,
                                  setToggled,
                                  setCollapsed,
                                  getCollapsedStatus,
                                }}
                              />
                            </div>
                            <Accordion.Collapse
                              eventKey={memberId}
                              scrollable={true}
                              className={accordionId}
                              id={accordionId + "-" + memberId}
                            >
                              <Card.Body
                                scrollable={true}
                                className="scrollable-dashboard scrollable-real-estate"
                              >
                                <div className="real-estate-table-container">
                                  <div className={`${true ? "table-wrapper" : ""}`}>
                                    <table className="real-estate-modal-table tableSticky">
                                      {dealTrackers.map((deal, index) => (
                                        <React.Fragment key={deal.ProjectId}>
                                          { index === 0 &&
                                            renderTableDealsColumns(deal.TableDeals[0].Columns)
                                          }
                                          { deal.TableDeals.map((tableDeal, rowIndex) =>
                                            <React.Fragment key={`row-${rowIndex}`}>
                                              { renderTableDealsRows(
                                                  tableDeal.Rows, -1,
                                                  deal.TableDeals[0]
                                                    .Columns
                                                      .find(m => ["active?", "active ?", "active"]
                                                      .includes(m?.Name?.toLowerCase()))?.Id
                                                )}
                                              </React.Fragment>
                                            )
                                          }
                                        </React.Fragment>
                                      ))}
                                    </table>
                                  </div>
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>                            
                          </Card>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </Accordion>
          </table>
          { selectedMember &&
            <VacationModal
              isAllRbc={isAllRbc}
              isStaffer={isStaffer}
              selectedMember={selectedMember}
              showState={show}
              onHideFunction={onHide}
            />
          }
          { selectedMember &&
            <DealModal
              isAllRbc={isAllRbc}
              isStaffer={isStaffer}
              selectedMember={selectedMember}
              showState={showDeals}
              onHideFunction={() => setShowDeals(false)}
            />
          }
        </div>
      </div>
    );
  }
  return null;
};

const ColumnPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
  Type: PropTypes.string.isRequired,
  Order: PropTypes.number.isRequired,
  LookupValues: PropTypes.string,
  LockStatus: PropTypes.number.isRequired,
});

const DataPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  ColumnId: PropTypes.number.isRequired,
  ColumnType: PropTypes.string,
  ColumnName: PropTypes.string,
  Value: PropTypes.string.isRequired,
  LookupValues: PropTypes.string,
  ColumnLockStatus: PropTypes.number.isRequired,
});

const RowPropType = PropTypes.shape({
  Id: PropTypes.number.isRequired,
  Row: PropTypes.number.isRequired,
  Data: PropTypes.arrayOf(DataPropType).isRequired,
});

const TablePropType = PropTypes.shape({
  Columns: PropTypes.arrayOf(ColumnPropType).isRequired,
  Rows: PropTypes.arrayOf(RowPropType),
});

DashboardDealTracker.propTypes = {
  isAllRbc: PropTypes.bool.isRequired,
  isStaffer: PropTypes.bool.isRequired,
  realEstateTrackerMembers: PropTypes.arrayOf(PropTypes.shape({
    CompanyId: PropTypes.number.isRequired,
    CompanyName: PropTypes.string.isRequired,
    UserId: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
    Type: PropTypes.string.isRequired,
    TypeColor: PropTypes.string.isRequired,
    ActiveDeals: PropTypes.number.isRequired,
    LastUpdated: PropTypes.string.isRequired,
    DealTracker: PropTypes.arrayOf(PropTypes.shape({
      ProjectId: PropTypes.number.isRequired,
      ProjectName: PropTypes.string.isRequired,
      OwnerUserId: PropTypes.number.isRequired,
      OwnerUserName: PropTypes.string,
      EditorUserId: PropTypes.number.isRequired,
      EditorUserName: PropTypes.string.isRequired,
      Editors: PropTypes.array,
      Type: PropTypes.string.isRequired,
      TypeColor: PropTypes.string.isRequired,
      ActiveDeals: PropTypes.number.isRequired,
      LastUpdated: PropTypes.string.isRequired,
      AllowDealsEdit: PropTypes.bool.isRequired,
      ProjectMembersList: PropTypes.array,
      TableDeals: PropTypes.arrayOf(TablePropType).isRequired,
    })).isRequired,
  })).isRequired,
};

export default DashboardDealTracker;
